import React from 'react';
import { UserPermissions } from '../../../../utils/UserPermissions';
import PositionsPayRateEdit from './PositionsPayRateEdit';
import PositionsPayRateReadOnly from './PositionsPayRateReadOnly';

function PositionsPayRateCard({ item }) {
  return (
    <div className="PositionsPayRateCard card">
      <div className="card-body">
        <h5 className="card-title">
          <i className={item.class}></i>{item.name}
        </h5>
        {UserPermissions('module_pay_rates_tab_positions_edit')
          ? <PositionsPayRateEdit item={item} />
          : <PositionsPayRateReadOnly item={item} />
        }
      </div>
    </div>
  )
}

export default PositionsPayRateCard
